export function CustomSliderDot() {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <circle cx="8" cy="8" r="4" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm0-2A6 6 0 1 0 8 2a6 6 0 0 0 0 12Z"
        fill="#fff"
      />
    </svg>
  )
}

export const sliderSettings = (dotColor = "white-on-black") => ({
  infinite: true,
  slidesToScroll: 1,
  speed: 1000,
  autoplaySpeed: 8000,
  autoplay: true,
  dots: true,
  arrows: false,
  fade: false,
  pauseOnHover: true,
  pauseOnDotsHover: true,
  pauseOnFocus: true,
  swipeToSlide: true,
  customPaging: () => (
    <a>
      <CustomSliderDot />
    </a>
  ), // li content with slick-active class on it when active, color applied with tailwind.css
  dotsClass: `slick-dots ${dotColor}`,
})
